<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="modal-add-pixel p-3">
      <div class="d-flex justify-content-between mb-2">
        <span class="modal-title"> Configurar pixel </span>
        <button class="btn btn-sm" @click="visible = false">
          <i class="fa fa-close text-secondary fs-18 font-weight-normal" />
        </button>
      </div>
      <a v-if="type" :href="INFO_MAP[type].link_url" target="_blank">
        Conheça o {{ INFO_MAP[type].name }}
        <i class="fa fa-arrow-up-right-from-square" />
      </a>

      <div v-if="step === 1" class="mt-6">
        <b-form-checkbox
          v-if="type === 'google_analytics'"
          v-model="form.is_ga4"
          switch
          id="is_ga4"
          class="mb-5"
        >
          Usar GA4
        </b-form-checkbox>

        <div class="row">
          <div class="col-12" :class="{ 'col-lg-6': customConversionLabel }">
            <form-group
              v-model="form.code"
              v-if="type"
              id="code"
              label="ID do pixel"
              :errors="errors.code"
              :placeholder="INFO_MAP[type].placeholder"
            />
          </div>

          <div v-if="customConversionLabel" class="col-lg-6">
            <form-group
              v-model="form.conversion_label"
              id="conversion_label"
              placeholder="Cole o label aqui"
              label="Label de conversão do Google Ads"
              :errors="errors.conversion_label"
            />
          </div>
        </div>
      </div>

      <second-step
        v-if="step === 2"
        class="mt-5"
        :form="form"
        :errors="errors"
        @update="updateForm"
      />

      <div class="submit-buttons">
        <button class="btn btn-secondary" @click="back">
          {{ step === 2 ? "Voltar" : "Cancelar" }}
        </button>
        <button class="btn btn-primary" @click="submit" :disabled="!isValid">
          <loading :show="isLoading">{{
            step === 2 ? "Concluir" : "Continuar"
          }}</loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { formFields } from "@/functions/helpers";
import SecondStep from "./SecondStep.vue";

export default {
  components: { SecondStep },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "facebook"
    },
    customConversionLabel: {
      type: Boolean,
      default: false
    },
    pixel: {
      type: Object,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: 1,
      visible: this.value,
      ...formFields([
        "type",
        "code",
        "is_ga4",
        "value_type",
        "payment_type",
        "fb_api_token",
        "track_purchase",
        "conversion_label",
        "custom_value_config",
        "track_initiate_checkout"
      ])
    };
  },
  computed: {
    INFO_MAP() {
      return {
        facebook: {
          name: "Facebook Ads",
          placeholder: "EX: 12345678901234",
          link_url:
            "https://www.facebook.com/business/help/952192354843755?id=1205376682832142"
        },
        google_ads: {
          name: "Google Ads",
          placeholder: "EX: AW-0123456789",
          link_url: "https://ads.google.com/intl/pt-BR_br/home/"
        },
        google_analytics: {
          name: "Google Analytics",
          placeholder: this.form.is_ga4
            ? "EX: G-1234567890"
            : "EX: UA-123456-00",
          link_url:
            "https://developers.google.com/analytics/devguides/platform?hl=pt-br"
        },
        kwai: {
          name: "Kwai",
          placeholder: "EX: 383231573614893114",
          link_url: "https://www.kwai.com/business"
        }
      };
    },
    isValid() {
      let validCode = this.form.code && this.form.code.length >= 12;
      let validValue = true;

      if (this.form.value_type === "custom_value") {
        let emptyMethod = this.form.custom_value_config.value_by_method.find(
          v => !v.payment_method || !v.value
        );

        if (
          (!this.form.custom_value_config.currency ||
            !this.form.custom_value_config.value_by_method.length ||
            !!emptyMethod) &&
          this.step === 2
        )
          validValue = false;
      }

      return validCode && validValue;
    }
  },
  methods: {
    updateForm(options = {}) {
      this.form = { ...this.form, ...options };
    },
    back() {
      if (this.step === 1) {
        this.visible = false;
      } else this.step -= 1;
    },
    submit() {
      if (this.step === 1) {
        this.step += 1;
        return;
      }

      let newPixel = { ...this.form };
      if (this.pixel !== null) {
        this.$emit("submitEdit", newPixel);
      } else {
        this.$emit("submit", newPixel);
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit("input", val);

      this.form = {
        code: "",
        type: this.type,
        track_purchase: true,
        track_initiate_checkout: true,
        payment_type: "all",
        value_type: "real_value",
        custom_value_config: {
          currency: "",
          value_by_method: [
            {
              payment_method: "",
              value: ""
            }
          ]
        },
        ...(this.pixel || {})
      };

      this.step = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.fit-scroll-content {
  overflow-x: hidden;
  max-height: 700px;
  @media screen and (max-width: 991px) {
    max-height: 600px;
  }
  a {
    font-size: 14px;
    color: #9955ffdd;
  }
  .custom-switch {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
  ::v-deep {
    .form-group {
      padding: 0;
      margin-top: 16px;
      label {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 4px;
        color: #736d80;
      }
      .el-input__inner,
      .form-control {
        border: 1px solid #c4c0cc;
        min-height: 40px;
        height: 40px;
      }
    }
  }
  .submit-buttons {
    gap: 16px;
    display: flex;
    margin-top: 32px;
    justify-content: flex-end;
    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
    .btn-secondary {
      order: 0;
      @media screen and (max-width: 991px) {
        order: 1;
      }
      border: none;
      color: #57586be0;
      background-color: rgba(119, 120, 142, 0.08) !important;
    }
    .btn-primary {
      order: 1;
      @media screen and (max-width: 991px) {
        order: 0;
      }
      border: none;
      background-color: #781effe0;
    }
  }
  @media screen and (min-width: 992px) {
    .row {
      padding: 0 10px;
      .col-lg-6,
      .col-12 {
        padding: 0 6px !important;
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  ::v-deep .modal-dialog {
    max-width: 100%;
  }
}
</style>
